import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button, IconButton, withStyles } from "@material-ui/core";
import Camera from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";
import { resizeImageByPercentage } from "utils/Utils";
import { Slider } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import PhotoCamera from '@material-ui/icons/PhotoCamera';
import { basicImageDimensions } from "assets/properties/properties";

const CameaComponent = ({
  classes,
  UploadCameraFile,
  label,
  type,
  imageResolutionPercentageFlag,
  cameraImageValidationFlag,
  image,
  imageIcon,
  imageDimensions,
  disabledCameraButton,
  setDisabledCameraButton,
}) => {
  const [showCamera, setShowCamera] = useState(false);
  const [showCameraImg, setShowCameraImg] = useState(false);
  const [customerImageUri, setCustomerImageUri] = useState("");
  const [keepImage,setKeepImage]= useState(true);
  const [hasNewCapture, setHasNewCapture] = useState(false);
  const [imageSize,setImageSize] = useState("");
  const onClickCamera = () => {
    setShowCamera(true);
    setShowCameraImg(false);
    setKeepImage(true);
    setDisabledCameraButton(true);
  };
  const [capturedDataUri, setCapturedDataUri] = useState("");
  const [resizePercentage, setResizePercentage] = useState(Number(imageResolutionPercentageFlag) || 100);
  const resizeImageByPercentageAsync = (dataUri, percentage) => {
  return new Promise((resolve, reject) => {
    resizeImageByPercentage(dataUri, percentage, (resizedDataUri) => {
      if (resizedDataUri) {
        resolve(resizedDataUri);
      } else {
        reject(new Error("Resizing failed"));
      }
    },
    imageDimensions ? JSON.parse(imageDimensions) : basicImageDimensions
  );
  });
};
useEffect(() => {
  const updateResizedImage = async () => {
    if (capturedDataUri && showCameraImg) {
      try {
        const resizedDataUri = await resizeImageByPercentageAsync(capturedDataUri, resizePercentage);
        const blob = await fetch(resizedDataUri).then((res) => res.blob());
        const imageUrl = URL.createObjectURL(blob);
        const imageSizeKB = Math.round(blob.size / 1024);
        setCustomerImageUri(imageUrl);
        setImageSize(imageSizeKB);
      } catch (error) {
        console.error("Error updating image with new resolution:", error);
      }
    }
  };

  updateResizedImage();
}, [resizePercentage]);
  const handleTakePhoto = async (dataUri, type) => {
  try {
    setCapturedDataUri(dataUri);
    const resizedDataUri = await resizeImageByPercentageAsync(dataUri, resizePercentage);
    const blob = await fetch(resizedDataUri).then((res) => res.blob());
    const imageSizeKB = Math.round(blob.size / 1024);
    const imageUrl = URL.createObjectURL(blob);
    switch (type) {
      case "CUSTOMER":
        setCustomerImageUri(imageUrl);
        setImageSize(imageSizeKB);
        setShowCamera(false);
        setShowCameraImg(true);
        setHasNewCapture(true);
        break;
      case "ORNAMENT":
        setCustomerImageUri(imageUrl);
        setImageSize(imageSizeKB);
        setShowCamera(false);
        setShowCameraImg(true);
        setHasNewCapture(true);
        break;
      default:
        setShowCamera(false);
        setShowCameraImg(false);
    }
    if(!cameraImageValidationFlag){
      UploadCameraFile(blob, type);
      setDisabledCameraButton(false);
    }
  } catch (error) {
    console.error("Error processing image:", error);
  }
};

  const handleCameraError = (error) => {
    console.log("handleCameraError", error);
  };
  const handleCameraStart = (stream) => {
    console.log("handleCameraStart");
  };
  const handleCameraStop = () => {
    console.log("handleCameraStop");
  };
  const keepCameraImage = async ()=>{
    const blob = await fetch(customerImageUri).then((res) => res.blob());
    setKeepImage(false);
    UploadCameraFile(blob, type);
    setDisabledCameraButton(false);
  }
  const PrettoSlider = withStyles({
    root: {
      color: brandTheme?.buttonColor,
      height: 8,
      '& .MuiSlider-rail':{
        width:'10px'
      },
      '& .MuiSlider-track':{
        width:'10px'
      },
    },
    thumb: {
      height: 20,
      width: 20,
      backgroundColor: '#fff',
      border: '2px solid currentColor',
      marginTop: -8,
      marginLeft: -12,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 8,
      borderRadius: 4,
    },
    rail: {
      height: 8,
      borderRadius: 4,
    },
  })(Slider);
  return (
    <div>
      <GridContainer style={{ marginTop: 0 }}>
        <GridItem xs={12} sm={12} md={12} lg={12}>
          <GridItem xs={12} sm={12} md={12} lg={12} style={{position:'relative'}}>
            <GridContainer   onClick={() => {
              if (!disabledCameraButton) {
                  onClickCamera();
                }
              }}
              role="button">
             {(!cameraImageValidationFlag || !showCameraImg) && (
                <GridItem
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    width: '300px',
                    height: '300px',
                    border: '1px solid #ccc',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    cursor: 'pointer',
                    overflow: 'hidden',
                    position: 'relative',
                  }}
                >
                  {(showCameraImg && !cameraImageValidationFlag) || image ? (
                    <div
                    className={classes.imageWrapper}
                  >
                    <img
                       src={customerImageUri || image}
                      alt="Captured"
                      style={{
                        width: '300px',
                        height: '300px',
                        objectFit: 'cover',
                        transition: 'opacity 0.3s ease',
                        opacity: disabledCameraButton ? 0.5 : 1,
                        pointerEvents: disabledCameraButton ? 'none' : 'auto',
                      }}
                    />
                    <div className={classes.overlay}>
                      Edit
                    </div>
                  </div>
                  ) : (
                    <img
                      src={imageIcon}
                      alt="Upload Placeholder"
                      style={{
                        width: '86%',
                        height: '81%',
                        objectFit: 'cover',
                        opacity: disabledCameraButton ? 0.5 : 1,
                        pointerEvents: disabledCameraButton ? 'none' : 'auto',
                      }}
                    />
                  )}
                </GridItem>
              )}
            </GridContainer>
            <GridContainer style={{justifyContent:'center'}}>
              {showCamera && (
                <GridItem xs={12} sm={12} md={12} lg={12}  className={classes.cameraContainer} style={{
              justifyContent: 'center',
              position: cameraImageValidationFlag && keepImage && !showCamera ? 'relative' : 'absolute',
              top: 0,
              left: '7px',
            }}>
                  <Camera
                    style={{
                      width: "300px",
                      height: "300px",
                    }}
                    onTakePhoto={(dataUri) => {
                      handleTakePhoto(dataUri, type);
                    }}
                    onCameraError={(error) => {
                      handleCameraError(error);
                    }}
                    isMaxResolution={true}
                    isFullscreen={false}
                    sizeFactor={2}
                    onCameraStart={(stream) => {
                      handleCameraStart(stream);
                    }}
                    onCameraStop={() => {
                      handleCameraStop();
                    }}
                  />
                </GridItem>
              )}
              {(showCameraImg) && (
                <>
                {(cameraImageValidationFlag) &&
                <GridContainer style={{alignItems: 'center',justifyContent:'center',width:"100%", height:"300px"}}>
                  <GridItem xs={12} sm={12} md={8} lg={8} style={{display:'flex',justifyContent:'center', padding:'0px !important', position:'relative'}}>
                     <div
                    className={classes.imageWrapper}
                    style={{width:"470px"}}
                    onClick={onClickCamera}
                    role="button"
                    >
                    <img src={customerImageUri} width="300" height="300" />
                     <div className={classes.overlay}>
                      Edit
                    </div>
                  </div>
                    {/* {keepImage &&
                  <GridItem xs={2} sm={2} md={2} lg={2} style={{maxWidth:'20px'}}>
                    <div style={{ height: 300, display: 'flex', alignItems: 'center' }}>
                      <PrettoSlider
                        orientation="vertical"
                        value={resizePercentage}
                        onChange={(e, newValue) => setResizePercentage(newValue)}
                        step={5}
                        min={5}
                        max={100}
                        marks
                        valueLabelDisplay="on"
                        valueLabelFormat={`${imageSize} kb`}
                      />
                    </div>
                  </GridItem>
                  } */}
                  </GridItem>
                </GridContainer>
                }
                  {cameraImageValidationFlag && keepImage && 
                  <GridContainer style={{display:'flex',flexDirection:"column", marginLeft:'-40px', width:'68%'}}>
                  <GridItem xs={12} sm={12} md={7} lg={7}>
                    <Button
                      size="small"
                      // className="bg-gradient-theme-left border-0"
                      onClick={() => keepCameraImage()}
                      // style={{marginLeft:"25px",textAlign:"center"}}
                      className={classes.nextButton2}
                      aria-label="upload report"
                    >
                      Keep
                    </Button>
                  </GridItem>
                  {keepImage &&
                  <GridItem xs={12} sm={12} md={7} lg={7}>
                    <Button
                      size="small"
                      // className="bg-gradient-theme-left border-0"
                      onClick={() => onClickCamera()}
                      // style={{marginLeft:"25px",textAlign:"center"}}
                      className={classes.nextButton2}
                      aria-label="upload report"
                    >
                      Take New
                    </Button>
                  </GridItem>
                  }
                  </GridContainer>
                 }
                </>
              )}
            </GridContainer>
          </GridItem>
        </GridItem>
      </GridContainer>
    </div>
  );
};

CameaComponent.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
};

export default CameaComponent;